import { Drawer } from "antd";
import { useEffect, useState } from "react";
import ContentBill from "./ContentBill";

function Bill({
  onClose,
  visible,
  data,
  storeInfo,
  storeId,
  setconfirmationModal,
}) {
  const [width, setWidth] = useState(window.innerWidth);
  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Drawer
        placement="right"
        width={width > 768 ? "40%" : "100%"}
        closable
        onClose={onClose}
        visible={visible}
        bodyStyle={{ padding: "0" }}
      >
        <ContentBill
          visible={visible}
          storeInfo={storeInfo}
          data={data}
          storeId={storeId}
          setconfirmationModal={setconfirmationModal}
        />
      </Drawer>
    </div>
  );
}

export default Bill;
